<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

// import WS from './websocket.js'

export default {
  name: 'App',
  data: function () {
    return {
    }
  },
  computed: {
    isScreen38496() {
      console.log('router path:: ', this.$route.path)
      return '/screen38496' === this.$route.path
      // const { width, height } = window.screen
      // console.log('screen :: ', width, height)
      // return width === 3840 && height === 960
    },
  },
  created() {},
  mounted() {
    // 初始化websocket连接
    // this.websocket = new WS({
    //   onmessage: (sn, data) => {
    //     console.log('sn = ', sn, '; data = ', data)
    //     this.$store.commit('realtime', data)
    //   },
    // })

    console.log('isScreenUltraWidth: ', this.isScreenUltraWidth)
  },
}
</script>

<style>
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  position: absolute;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue